import {routing} from '@/i18n/routing';
import {useLocale, useTranslations} from 'next-intl';
import LocaleSwitcherBtn from './LocaleSwitcherBtn';

export default function LocaleSwitcher() {
  const t = useTranslations('LocaleSwitcher');
  const locale = useLocale();

  return (
    <LocaleSwitcherBtn defaultValue={locale}>
      {routing.locales.map((cur) => (
        <option key={cur} value={cur}>
          {t('locale', {locale: cur})}
        </option>
      ))}
    </LocaleSwitcherBtn>
  );
}
